// eslint-disable-next-line no-unused-vars
import { Navigate, Outlet } from 'react-router-dom';

const ProtectedRoute = ({ isAuthenticated }) => {
  return <>{isAuthenticated ? <Outlet /> : <Navigate to='/login' replace />}</>;
};

export default ProtectedRoute;
